module.exports = __webpack_public_path__ + "static/media/Earth.7b0df7fe.jpg";